const PENDING_DRAIN_TTL = 15000;
let pendingDrains = [];

const Firebase = {
  install(Vue, options) {
    Vue.mixin({
      data() {
        return {};
      },

      computed: {
        currentUser: function () {
          return this.$store.getters["user/currentUser"];
        },
        isWriteable: function () {
          return this.$store.getters["externalScripts/getIndexedDBWriteable"];
        },
        scriptLoaded: function () {
          return this.$store.getters["externalScripts/getFirebaseScriptLoaded"];
        },
      },
      methods: {
        firebaseLogEvent: function (eventName, payload = "") {
          // console.log("FireBase EVENT >>", eventName, payload);
          if (!this.isWriteable) {
            return;
          }

          if (typeof firebase === "undefined" || !firebase.analytics) {
            return;
          }
          firebase.analytics().logEvent(eventName, payload);
        },
        firebaseSetScreen: function (screenName, screenClass) {
          if (!this.isWriteable) {
            return;
          }
          if (!this.scriptLoaded) {
            return;
          }
          if (typeof firebase === "undefined") {
            return false;
          }

          firebase
            .analytics()
            .setCurrentScreen(screenName, { screen_class: screenClass });
        },
        firebaseSetUser: function (methodName) {
          if (!this.isWriteable) {
            return;
          }
          if (!this.scriptLoaded) {
            return;
          }
          if (typeof firebase === "undefined") {
            return false;
          }

          firebase.analytics().setUserId(this.currentUser.id);
          firebase
            .analytics()
            .setUserProperties({ method: methodName, source: "WEB" });
        },

        firebaseClickItemHeader: function (itemId) {
          this.firebaseLogEvent("select_content", {
            content_type: "btn",
            item_id: itemId,
            item_category: "HEADER",
          });
        },
        firebaseClickItemFooter: function (itemId) {
          this.firebaseLogEvent("select_content", {
            content_type: "btn",
            item_id: itemId,
            item_category: "FOOTER",
          });
        },
        firebaseClickItemMenu: function (itemId) {
          this.firebaseLogEvent("select_content", {
            content_type: "btn",
            item_id: itemId,
            item_category: "MENU",
          });
        },
        firebaseClickItemTreasury: function (itemId) {
          this.firebaseLogEvent("select_content", {
            content_type: "btn",
            item_id: itemId,
            item_category: "TREASURY",
          });
        },
        firebaseClickItemShop: function (itemId) {
          this.firebaseLogEvent("select_content", {
            content_type: "btn",
            item_id: itemId,
            item_category: "SHOP",
          });
        },
        firebaseClickItemOffer: function (itemId) {
          this.firebaseLogEvent("select_content", {
            content_type: "btn",
            item_id: itemId,
            item_category: "OFFER",
          });
        },
        firebaseClickItemNews: function (itemId, itemCategory) {
          this.firebaseLogEvent("select_content", {
            content_type: "btn",
            item_id: itemId,
            item_category: itemCategory,
          });
        },
        firebaseClickItemAnnouncement: function (itemId) {
          this.firebaseLogEvent("select_content", {
            content_type: "btn",
            item_id: itemId,
            item_category: "ANNOUNCEMENT",
          });
        },
        firebaseViewOffer: function (promotion_name) {
          this.firebaseLogEvent("view_promotion", {
            promotion_name: promotion_name,
          });
        },
        firebaseClickItemProfile: function (itemId) {
          this.firebaseLogEvent("select_content", {
            content_type: "btn",
            item_id: itemId,
            item_category: "PROFILE",
          });
        },
        firebasePurchase(payload) {
          this.firebaseLogEvent("purchase", {
            item_id: payload.offer_id,
            value: payload.price,
            currency: payload.currency,
            payment_method: payload.payment_method,
          });
        },
        firebaseBeginCheckout(payload) {
          this.firebaseLogEvent("begin_checkout", {
            item_id: payload.offer_id,
            value: payload.price,
            currency: payload.currency,
          });
        },
        firebaseVirtualCurrencyDrain: function (
          itemName,
          currency,
          value,
          category
        ) {
          this.firebaseLogEvent("spend_virtual_currency", {
            item_name: itemName,
            virtual_currency_name: String(currency || "").toLowerCase(),
            value: value,
            item_category: category,
          });
        },
        // Report a spend and claim the matching wallet push, so the
        // `.user.wallet.updated` fallback in wsChannels stays quiet for it.
        // Every attributed spend goes through here, whatever the currency.
        firebaseSpend: function (itemName, currency, value, category) {
          const type = String(currency || "").toUpperCase();
          const amount = Math.round(Math.abs(Number(value) || 0));
          if (!type || amount <= 0) return;
          pendingDrains.push({ type, amount, ts: Date.now() });
          this.firebaseVirtualCurrencyDrain(itemName, type, amount, category);
        },
        // Matches on currency *and* amount: a crown drain must not consume a
        // pending gold entry that happens to be the same size.
        firebaseConsumeDrain: function (currency, value) {
          const type = String(currency || "").toUpperCase();
          const amount = Math.round(Math.abs(Number(value) || 0));
          const now = Date.now();
          pendingDrains = pendingDrains.filter(
            (d) => now - d.ts < PENDING_DRAIN_TTL
          );
          const idx = pendingDrains.findIndex(
            (d) => d.type === type && d.amount === amount
          );
          if (idx === -1) return false;
          pendingDrains.splice(idx, 1);
          return true;
        },
        firebaseOnScroll: function (source, destination, distance) {
          this.firebaseLogEvent("web_scroll", {
            source: source,
            destination: destination,
            distance: distance,
          });
        },
      },
    });
  },
};

export default Firebase;
